import { FocusCss } from '@tvg/fuse-utils';
import styled from 'styled-components';
import { Icon as IconElement } from '../../fuse-icon-element/src/icon-element';
import { TappableArea } from '../../fuse-tappable-area/src/tappablearea';

const StyledPlainIconButton = styled.button.attrs({
	className: 'fuse-plain-icon-button',
})`
	background: none;
	border: none;
	display: inline-flex;
	margin: 0;
	padding: 0;
	position: relative;

	&:active,
	&:focus {
		${FocusCss}
	}

	&:hover,
	&:focus {
		color: var(--color-brand-dark);
		cursor: pointer;
	}

	&:active {
		color: var(--color-global-black);
	}

	&:focus .fuse-plain-icon-button__icon,
	&:hover .fuse-plain-icon-button__icon {
		background: var(--color-brand-dark);
	}

	&:active .fuse-plain-icon-button__icon {
		background: var(--color-global-black);
	}

	&[disabled] {
		color: var(--color-global-grey400);
		background-color: unset;
		border: none;
		cursor: auto;
	}

	&[disabled] .fuse-plain-icon-button__icon {
		background-color: var(--color-global-grey400);
	}

	${TappableArea}
`;

const StyledIcon = styled(IconElement).attrs({
	className: 'fuse-plain-icon-button__icon',
	'data-testid': 'fuse-plain-icon-button-icon-test-id',
})``;

export { StyledIcon, StyledPlainIconButton };
